import { render } from "./TheMenu.vue?vue&type=template&id=71521720&scoped=true&bindings={\"show\":\"props\",\"tryClose\":\"options\"}"
import script from "./TheMenu.vue?vue&type=script&lang=js"
export * from "./TheMenu.vue?vue&type=script&lang=js"

import "./TheMenu.vue?vue&type=style&index=0&id=71521720&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71521720"

export default script